<template>
  <ChillerPage v-if="mode === 'chiller'" />
  <div
    v-else
    class="bg"
    style="
      background: linear-gradient(#0009, #0007), url(static/img/background.jpg);
    "
  >
    <v-container grid-list-lg class="mb-5">
      <v-layout row wrap>
        <BackSimulator></BackSimulator>
        <v-flex xs12 class="text-xs-center">
          <img src="static/logo/logo.svg" width="220" class="mx-auto mt-2" />
        </v-flex>
        <v-flex xs12>
          <h1 class="titulo mt-5">Refrigeração</h1>
        </v-flex>
        <v-flex xs12 sm6 md4 lg3 v-for="s in simuladores" :key="s.id">
          <v-card class="card-custom-two" @click="createUrl(s.link)">
            <v-card-text>
              <v-icon color="primary" size="46">{{ s.icon }}</v-icon>
              {{ s.name }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
let _base;

try {
  _base = require("@/page/_base.vue").default;
} catch (err) {
  _base = require("@/framework/page/_base.vue").default;
}

import BackSimulator from "@/page/widget/backSimulator.vue";
import ChillerPage from "@/page/chiller.vue";

export default {
  extends: _base,
  components: {
    BackSimulator,
    ChillerPage,
  },
  data() {
    return {
      mode: null,
      simuladores: [
        {
          id: 1,
          name: "Chiller",
          link: "refrigeracao?mode=chiller",
          icon: "mdi mdi-fan-chevron-up",
        },
      ],
    };
  },
  mounted() {
    // this.$router.go(-1);

    const urlMode =
      this.$route && this.$route.query ? this.$route.query.mode : null;

    if (urlMode === "chiller") {
      this.mode = "chiller";
    }
  },
  methods: {
    createUrl(item) {
      window.open("#/" + item, "_self");
    },
  },
};
</script>

<style lang="scss">
@import "@/theme/styles/base.scss";

.bg {
  min-height: 100svh;
  min-width: 100svw;
  background-size: cover !important;
  background-attachment: fixed !important;
  background-repeat: no-repeat !important;
}

.titulo {
  text-transform: uppercase;
  font-size: 32px !important;
  background: linear-gradient(
    135deg,
    #009247 0%,
    #8cc640 25%,
    #009247 50%,
    #bcff63 70%,
    #009247 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 150%;
  font-weight: 800 !important;
}

.card-custom-two {
  backdrop-filter: blur(6px) brightness(0.8) !important;
  background: linear-gradient(
    -45deg,
    tint($brand-primary, 90%),
    tint($brand-primary, 96%)
  ) !important;
  border: 2px solid tint($brand-primary, 80%) !important;
  border-radius: 1.4rem !important;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1 / 0.5;
  box-shadow: inset 0 3px 56px tint(#fff, 90%),
    inset 0 3px 156px tint(#fff, 99%) !important;
  cursor: pointer;

  &:hover {
    border-color: $brand-primary !important;
    backdrop-filter: blur(6px) brightness(1.2) !important;
    background: linear-gradient(
      -45deg,
      tint($brand-primary, 80%),
      tint($brand-primary, 86%)
    ) !important;
  }

  @media (min-width: 960px) {
    aspect-ratio: 1 / 0.75;
  }

  .v-card__text {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-weight: 800 !important;
    font-size: 18px !important;
  }
}
</style>
